var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c("v-card-title", { staticClass: "grey lighten-4 p-2" }, [
        _c("h4", { staticClass: "m-0" }, [_vm._v("Delivery")]),
      ]),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "m-2" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6" } },
            [
              _c("h6", [_vm._v("Day before")]),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6", md: "5" } },
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "" },
                          model: {
                            value: _vm.reservation.pickup_day,
                            callback: function ($$v) {
                              _vm.$set(_vm.reservation, "pickup_day", $$v)
                            },
                            expression: "reservation.pickup_day",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { label: "Yes", value: "day_before" },
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: { label: "No", value: "day_of" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "6", md: "7" } },
                    [
                      _c("with-validation", {
                        attrs: { field: "pickup_hour" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ bind, on }) {
                              return [
                                _c("v-select", {
                                  attrs: {
                                    items: _vm.pickup_hours,
                                    "item-value": "value",
                                    "item-text": "time",
                                    label: "Select pickup time",
                                  },
                                  model: {
                                    value: _vm.reservation.pickup_hour,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.reservation,
                                        "pickup_hour",
                                        $$v
                                      )
                                    },
                                    expression: "reservation.pickup_hour",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "5" } },
            [
              _c("v-alert", { attrs: { outlined: "", elevation: "2" } }, [
                _c("b", [_vm._v("Select preferred delivery day and time: ")]),
                _vm._v(" "),
                _c("h6", [
                  _vm._v(
                    "(we are showing all the times that are available for that day, if your preferred time is not available select the best time for your group)"
                  ),
                ]),
                _vm._v(" "),
                _c("b", [_vm._v(" Do you want to pick up the day before? ")]),
                _vm._v(" "),
                _c("h6", [
                  _vm._v(
                    ' (If you select "No", you will be picking up on the day of your reservation) '
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "m-2 pb-5" },
        [
          _c(
            "v-col",
            {
              staticStyle: { "margin-bottom": "-30px" },
              attrs: { cols: "12", md: "7" },
            },
            [
              _c("h6", [
                _vm._v(
                  "Please select a time for your delivery, times are limited to 1 delivery per hour"
                ),
              ]),
              _vm._v(" "),
              _c("h6", [
                _vm._v(
                  "Do you know the Property Name or Address you will be staying:"
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "5" } },
            [
              _c(
                "v-radio-group",
                {
                  attrs: { row: "" },
                  model: {
                    value: _vm.delivery_address_radio,
                    callback: function ($$v) {
                      _vm.delivery_address_radio = $$v
                    },
                    expression: "delivery_address_radio",
                  },
                },
                [
                  _c("v-radio", { attrs: { label: "Yes", value: true } }),
                  _vm._v(" "),
                  _c("v-radio", { attrs: { label: "No", value: false } }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }